import { Page } from '@evogard/ui';
import { NotFoundContent } from '../../components/NotFoundContent.js';

/**
 * O endereço que não existe, DENTRO da aplicação.
 *
 * Até 26/10/2026 o único `notFoundComponent` era o da raiz: a tela abria solta,
 * sem menu, e o botão "Ir para o início" fazia `location.assign('/')` —
 * recarregava a aplicação inteira (bundles, sessão, preferências) para chegar a
 * uma tela que estava a um clique. Pendurada em `authenticated`, ela abre com
 * o menu em volta, e toda saída é navegação do roteador: instantânea.
 *
 * O corpo é `NotFoundContent`, o mesmo da ficha que não existe
 * (`MissingRecord`): as duas respostas são uma tela só.
 */
export function NotFoundScreen() {
  return (
    <Page>
      <NotFoundContent />
    </Page>
  );
}
